import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import type { RouterContext } from '@shared/config/router-context';
import { canAccessAnalyticsGear } from '@shared/lib';

/**
 * Analytics - Gear Express Prototype
 *
 * Route: /:locale/analytics/gear-express
 */
export const Route = createFileRoute('/$locale/_authenticated/analytics/gear-express')({
  beforeLoad: ({ context, params }) => {
    const { ability } = context as RouterContext;

    if (!canAccessAnalyticsGear(ability)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: '/$locale/unauthorized',
        params: { locale: params.locale },
      });
    }

    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/$locale/analytics-gear',
      params: { locale: params.locale },
    });
  },
  validateSearch: z.object({
    tab: z.enum(['overview', 'weekly-report']).optional(),
    week: z.string().optional(),
    start: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .optional(),
    end: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .optional(),
  }),
});
